import { usePostalCodeValidation, getCountryByCode } from 'postal-code-checker';
import postcodesFormulas from '@/settings/postcodes-formulas';
const {validatePostalCode:isValidPostalCode} = usePostalCodeValidation();

export const validatePostalCode = (postalCode, countryCode) => {
  let code = countryCode;
  const country = getCountryByCode(code);
  if (!country) {
    code = 'INTL';
    if (postcodesFormulas[countryCode]) {
      return postcodesFormulas[countryCode].test(postalCode);
    }
    return postcodesFormulas[code].test(postalCode);
  }
  // Check if the country code is valid
  const isValid = isValidPostalCode(countryCode, postalCode);
  return isValid;
};
